module.exports = __webpack_public_path__ + "img/symphony_600_white.9676522d.jpg";